module.exports = {
  title: '用户列表',
  route: {
    path: 'user-manage',
    children: {
      path: 'user-list',
    },
  },
};
